import { render } from "./RegSuccess.vue?vue&type=template&id=1ccee0f5"
import script from "./RegSuccess.vue?vue&type=script&lang=js"
export * from "./RegSuccess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__